<template><div><h1 id="ergebniswert" tabindex="-1"><a class="header-anchor" href="#ergebniswert"><span>Ergebniswert</span></a></h1>
<p>Ergebniswert — Beschreibt einen Ergebniswert für das Reportingtool</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Pro Ergebniswert erstellt das Programm eine Tabelle, in der die X- und Y-Achsen und der entsprechende Ergebniswert eingetragen werden. Es können beliebig viele Ergebniswerte pro Auswertung definiert werden.</p>
<p>Pfad: <code v-pre>Systemverwaltung → Tabellen → Systemtabellen → Reportingtool → Ergebniswerte</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Tabelle</dt>
<dd>Ergebniswert-ID</dd>
<dt>Bezeichnung</dt>
<dd>Beschreibungstext</dd>
</dl>
<p>Analog zu den Gruppierungen sind auch die Ergebniswerte abhängig von der im Auswertungskopf gewählten Quelle. Diese Übersicht zeigt pro Quelle alle verfügbaren Ergebniswerte und gibt ein Beispiel für eine mögliche Dateneingabe, wo dies notwendig ist. Die Ergebniswerte können auf Anfrage ebenfalls ausgebaut werden.</p>
<p><strong>Tabelle 37. Reportingtool Ergebniswerte</strong></p>
<table>
<thead>
<tr>
<th>Quelle</th>
<th>Ergebniswert</th>
<th>Beispiele Dateneingabe (wo nötig)</th>
</tr>
</thead>
<tbody>
<tr>
<td>Adressen</td>
<td>Anzahl Adressen</td>
<td></td>
</tr>
<tr>
<td>Anzahl Zusagen (Typ)</td>
<td>mit</td>
<td></td>
</tr>
<tr>
<td>Umsatz Typ ___ aus <code v-pre>&lt;jahr&gt;</code> bis <code v-pre>&lt;jahr&gt;</code></td>
<td>Umsatz Typ SPE aus 1999 bis 1999</td>
<td></td>
</tr>
<tr>
<td>Umsatz R-Ereignis __<strong>.</strong> im Zeitraum 99.99.99 bis 99.99.99</td>
<td>Umsatz R-Ereignis 1234.56 im Zeitraum 01.01.99 bis 31.12.99</td>
<td></td>
</tr>
<tr>
<td>Umsatz Typ ___ im Zeitraum 99.99.9999 bis 99.99.9999</td>
<td>Umsatz Typ SPE im Zeitraum 01.01.1999 bis 31.12.1999</td>
<td></td>
</tr>
<tr>
<td>Artikel</td>
<td>Anzahl Artikel</td>
<td></td>
</tr>
<tr>
<td>Verkaufsumsatz im Zeitraum <code v-pre>&lt;mm&gt;&lt;yy&gt;</code> bis <code v-pre>&lt;mm&gt;&lt;yy&gt;</code></td>
<td>Verkaufsumsatz im Zeitraum 0199 bis 0699</td>
<td></td>
</tr>
<tr>
<td>Aufträge</td>
<td>Anzahl Aufträge</td>
<td></td>
</tr>
<tr>
<td>Auftragswert</td>
<td></td>
<td></td>
</tr>
<tr>
<td>Generelle Ergebniswerte</td>
<td>Durchschnittswert Ergebniswert aus Tabelle a) / Ergebniswert aus Tabelle b)</td>
<td>Ergebniswert 2/1</td>
</tr>
<tr>
<td>Prozentsatz am Gesamtwert von Ergebniswert a)</td>
<td>Ergebniswert 1</td>
<td></td>
</tr>
</tbody>
</table>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/referenz/refs/ft.refdata.rtjob.html" title="Reportingtool">Reportingtool</RouteLink></p>
</div></template>


